export default __webpack_public_path__ + "static/media/reshet13.6baa9b36.svg";